import { render, staticRenderFns } from "./modal-educate-users.vue?vue&type=template&id=0d0b46bb&scoped=true"
import script from "./modal-educate-users.vue?vue&type=script&lang=js"
export * from "./modal-educate-users.vue?vue&type=script&lang=js"
import style0 from "./modal-educate-users.vue?vue&type=style&index=0&id=0d0b46bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b46bb",
  null
  
)

export default component.exports